import { Link } from "react-router-dom"
import { RowType } from "../../types"
import { getBrandColor } from "../../utils"
import { tableStyles } from "../../styles"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { Box } from "@material-ui/core"
import { useMarketsWithRegions } from "../../hooks/useMarketsWithRegions"
import { useMemo } from "react"
import { useGetUserInfo } from "../../hooks/useGetUserInfo"

const Dot = ({
  type,
  streamColor,
  name,
}: {
  type: string
  streamColor?: string
  name: string
}) => {
  return (
    <div className={tableStyles.dotIconContainer}>
      <div
        className={tableStyles.dotIcon}
        style={{
          backgroundColor:
            type === "client" ? streamColor : getBrandColor(name),
        }}
      ></div>
    </div>
  )
}

interface NameProps {
  type: "brand" | "client" | "market"
  row: RowType
}
export function NameRenderer({ type, row }: NameProps) {
  const { pathname, search } = useRevenueParams()
  const { marketsWithRegions } = useMarketsWithRegions()
  const newSearch = new URLSearchParams(search)
  const { isGmpUser } = useGetUserInfo()

  switch (type) {
    case "brand":
      newSearch.set("brand", row.name)
      break
    case "client":
      newSearch.set("client", row.id)
      break
    case "market":
      newSearch.set("market", row.name)
      newSearch.set(
        "region",
        marketsWithRegions.find((x) => x.name === row.name)?.region || "All",
      )
      break
  }

  const to = { pathname, search: newSearch.toString() }

  const isLinkEnabled = useMemo(() => {
    switch (type) {
      case "brand":
      case "client":
        return !isGmpUser

      default:
        return true
    }
  }, [type, isGmpUser])

  const streamColor =
    row.stream === "silver"
      ? "var(--other-silver)"
      : row.stream === "magenta"
        ? "var(--other-magenta)"
        : `var(--${row.stream})`

  return (
    <Box alignItems="center" display="flex" textAlign="left">
      <Dot type={type} streamColor={streamColor} name={row.name} />
      {isLinkEnabled ? (
        <Link className={tableStyles.cell} to={to} title={row.name}>
          <div className={tableStyles.truncateText}>{row.name}</div>
        </Link>
      ) : (
        row.name
      )}
    </Box>
  )
}
